// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__36ZK4","title":"Header_title__1JjFN","side":"Header_side__oxNV3"};